import { useEffect, useState } from 'react';
import { AdminService } from '../../types';

const useDeletingPage = () => {
  const [data, setData] = useState<AdminService.Pages.List>();
  const [isAlertDialog, setAlertDialog] = useState(false);
  const [isSuccessDialog, setSuccessDialog] = useState(false);
  const [page, setPage] = useState<AdminService.Pages.One>();

  const deletePageFromDB: (page: AdminService.Pages.One) => void = async () => {
    try {
      if (page) {
        await fetch(
          'https://server.gold-race.org/api/site-manager/pages' +
            `?pageID=${page.id}`,
          {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
      }

      setAlertDialog(!isAlertDialog);
      setSuccessDialog(!isSuccessDialog);
    } catch (error) {
      return alert(error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const data = await fetch(
        'https://server.gold-race.org/api/site-manager/pages'
      );
      const response = await data.json();

      setData(response);
    };

    fetchData();
  }, []);

  return {
    page,
    data,
    isAlertDialog,
    isSuccessDialog,
    setPage,
    setAlertDialog,
    setSuccessDialog,
    deletePageFromDB,
  };
};

export default useDeletingPage;
